import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconCircleArrowUp = ({ color = 'var(--color-semantic-success)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
                <path d="M5.41276 10.8216L5.65554 11.0661C5.73195 11.1424 5.83361 11.1845 5.94225 11.1845C6.05084 11.1845 6.15262 11.1424 6.22902 11.0661L8.99852 8.29646L11.7712 11.0692C11.8475 11.1455 11.9493 11.1875 12.0579 11.1875C12.1664 11.1875 12.2683 11.1455 12.3446 11.0692L12.5875 10.8262C12.7456 10.6682 12.7456 10.4108 12.5875 10.2528L9.28625 6.93974C9.20996 6.86345 9.10831 6.8097 8.99876 6.8097L8.99749 6.8097C8.88884 6.8097 8.78719 6.86351 8.7109 6.93974L5.41276 10.2438C5.33635 10.3201 5.29441 10.4249 5.29429 10.5335C5.29429 10.6421 5.33635 10.7454 5.41276 10.8216Z" fill="#1ECAB8" />
            </g>
            <circle cx="9" cy="9" r="8.5" stroke={color} />
            <defs>
                <clipPath id="clip0">
                    <rect width="7.41176" height="7.41176" fill="white" transform="translate(12.7061 12.7051) rotate(-180)" />
                </clipPath>
            </defs>
        </svg>
    </div>
);

export default IconCircleArrowUp;
